import React, { Fragment, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import PerfilBasicoCliente from "./PerfilBasicoCliente";
import Intereses from "./Intereses";
import Comentarios from "./Comentarios";
import Alertas from "./Alertas";
import { useParams } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";


const Login = () => {
  const [usuario, setUsuario] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [comments, setComments] = useState([]);
  const [intereses, setIntereses] = useState([]);
  const [idInteresado, setIdInteresado] = useState("");

  const history = useHistory();

  const methods = useForm();

  function iniciarSesion() {
    let data = {
      usuario: usuario,
      contrasena: contrasena,
    };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };

    fetch(`${process.env.REACT_APP_API_URL}/login`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
       // console.log(data);
        if (data[0].token && data[0].token !== "") {
          localStorage.setItem("token", data[0].token);
          history.push("/bienvenido");
        } else {
          alert(data);
        }
      });
  }

  return (
    <div className="container-fluid ps-md-0">
      <div className="row g-0">
        <div className="d-none d-md-flex col-md-12 col-lg-12 bg-image align-content-lg-center">
          <div className="col-md-10 col-lg-10">
            <div className="login d-flex align-items-center py-5">
              <div className="container">
                <div className="row">
                  <div className="col-md-4 col-lg-4 mx-auto padre">
                    <br></br>
                    <h3 className="login-heading mb-4">
                      My Diamond Central
                      <br></br>
                    </h3>
                    <div className="form-floating mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="floatingInput"
                        onChange={(e) => {
                          setUsuario(e.target.value);
                        }}
                      />
                      <label htmlFor="floatingInput">Usuario</label>
                    </div>
                    <div className="form-floating mb-3">
                      <input
                        type="password"
                        className="form-control"
                        id="floatingPassword"
                        onChange={(e) => {
                          setContrasena(e.target.value);
                        }}
                      />
                      <label htmlFor="floatingPassword">Contraseña</label>
                    </div>

                    {/* <div className="form-check mb-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                        defaultValue=""
                          id="rememberPasswordCheck"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="rememberPasswordCheck"
                        >
                          Remember password
                        </label>
                      </div> */}

                    <div className="d-grid">
                      <button
                        className="btn btn-lg  btn-dark btn-login text-uppercase fw-bold mb-2"
                        type="submit"
                        onClick={(e) => {
                          iniciarSesion();
                        }}
                      >
                        Iniciar Sesión
                      </button>
                      {/* <div className="text-center">
                          <a className="small" href="#">
                            Forgot password?
                          </a>
                        </div> */}
                    </div>
                    <br></br>
                    <br></br>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
